import * as Preact from "preact"

import "@fae/source/views/components/TileTemplateThumbnail.less"
import * as tilespreadFormats from "@fae/source/models/dev/tilespread-formats.js"
const WANG_DEMO_INDEX = 1

export default class UnitTemplateSprite {
    render() {
        return(
            <div class="TileTemplateThumbnail" style={this.imageStyle}/>
        )
    }
    get imageStyle() {
        const imageStyle = {}
        if(this.props.template.image != undefined) {
            imageStyle["background-image"] = "url(" + this.props.template.image.src + ")"
            if(this.props.template.tilespreadType == "corner-match") {
                imageStyle["background-size"] = "4em"
                imageStyle["background-position-x"] = "-" + tilespreadFormats.wangCornerMatch[WANG_DEMO_INDEX].x + "em"
                imageStyle["background-position-y"] = "-" + tilespreadFormats.wangCornerMatch[WANG_DEMO_INDEX].y + "em"
            }
            if(this.props.template.tilespreadType == "corner-continuous") {
                imageStyle["background-size"] = "4em"
                imageStyle["background-position-x"] = "-" + tilespreadFormats.wangCornerContinuous[WANG_DEMO_INDEX].x + "em"
                imageStyle["background-position-y"] = "-" + tilespreadFormats.wangCornerContinuous[WANG_DEMO_INDEX].y + "em"
            }
            if(this.props.template.tilespreadType == "edge-match") {
                imageStyle["background-size"] = "4em"
                imageStyle["background-position-x"] = "-" + tilespreadFormats.wangEdgeMatch[WANG_DEMO_INDEX].x + "em"
                imageStyle["background-position-y"] = "-" + tilespreadFormats.wangEdgeMatch[WANG_DEMO_INDEX].y + "em"
            }
        }
        if(this.props.template.images != undefined) {
            imageStyle["background-image"] = "url(" + this.props.template.images[WANG_DEMO_INDEX].src + ")"
        }
        if(this.props.template.image == undefined
        && this.props.template.images == undefined
        && this.props.template.tint != undefined) {
            imageStyle["background-color"] = "rgb(" + this.props.template.tint.R + "," + this.props.template.tint.G + "," + this.props.template.tint.B + ")"
        }
        return imageStyle
    }
}
